import React, { Component } from 'react';

class TaamParser_Examples extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getTranslatedContent(langCode){
    if(!["he", "en"].includes(langCode)){ // setting langCode to "en" if invalid code given
      langCode = "en";
    }
    var retVal;
    if(langCode === "he"){
      retVal = <>

        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><b><u><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>השוואת
                טעם תחתון
                וטעם עליון: מעשה
                ראובן</span></u></b></p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - corrected: opening the parser on this pasuk shows the meurav reading by default, not taam tachton; either special reading requires an explicit selection from its own menu */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>פתח
            את מנתח
            הטעמים על <b>בראשית
              לה:כב</b> (מעשה
            ראובן).</span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}> </span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>מאחר
            שהפסוק טרם
            מוצג באחת
            משתי הגרסאות
            המיוחדות, הוא
            מוצג תחילה
            בגרסה המעורבת
            (מעורב), כאשר
            שני הבוררים <b>טעם
              תחתון</b> ו<b>טעם
              עליון</b> נשארים
            ללא בחירה.</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>לחץ
            על בורר <b>טעם
              תחתון</b> ובחר
            את הערך תחת
            הכותרת "מעשה
            ראובן".</span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}> </span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>המנתח
            יעבור לגרסת
            ה<b>טעם
              תחתון</b> של
            הקטע; הבורר
            יציג כעת את
            הפסוק הנוכחי
            כנבחר, בעוד
            בורר <b>טעם
              עליון</b> יישאר
            ללא בחירה.</span></p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - added taamParser_tachton1_withMenu.jpg (tachton dropdown open, showing selection under Mayse Reuven heading) and taamParser_tachton1.jpg (resulting clean tachton reading tree) */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR"><img width={680} height={435} id="Picture 100" src="helpDialogImages/taamParser_tachton1_withMenu.jpg" /></span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR"><img width={680} height={436} id="Picture 101" src="helpDialogImages/taamParser_tachton1.jpg" /></span></p>
        {/* END */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>כעת
            לחץ על בורר <b>טעם
              עליון</b> ובחר
            באותו
            הערך.</span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}> </span><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>המנתח
            יעבור לגרסת
            ה<b>טעם
              עליון</b> של
            אותו הקטע;
            הבורר יציג
            כעת את הפסוק
            הנוכחי כנבחר,
            בעוד בורר <b>טעם
              תחתון</b> יחזור
            להיות ללא
            בחירה.</span></p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - added taamParser_elyon_withMenu.jpg (elyon dropdown open, showing selection under Mayse Reuven heading) and taamParser_elyon.jpg (resulting clean elyon reading tree) */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR"><img width={680} height={391} id="Picture 102" src="helpDialogImages/taamParser_elyon_withMenu.jpg" /></span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR"><img width={680} height={392} id="Picture 103" src="helpDialogImages/taamParser_elyon.jpg" /></span></p>
        {/* END */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - swapped clause order (elyon first, tachton second) per user request, to flow from the reading just selected back to the earlier one */}
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>עץ
            הניתוח עצמו
            ישתנה בהתאם:
            ה<b>טעם
              עליון</b> מאחד
            את התוכן
            לכדי יחידה
            אחת, בעוד
            שה<b>טעם
              תחתון</b> קורא
            את הקטע כפרוס
            על פני שני
            פסוקים
            נפרדים –
            ולכן שני עצי
            הניתוח, אף
            שמבוססים על
            אותן המילים
            בערך, נבנים
            בצורה שונה.</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>ניתן
            לחזור לגרסת
            ה<b>טעם
              תחתון</b> בכל
            עת על ידי
            בחירה מחדש
            מתוך בורר <b>טעם
              תחתון</b>, וכך
            לעבור הלוך
            ושוב בין שתי
            הגרסאות
            לצורך
            השוואה.</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span dir="LTR">&nbsp;</span></p>
        <p className="MsoNormal" dir="RTL" style={{textAlign: 'right', direction: 'rtl', unicodeBidi: 'embed'}}><span lang="HE" style={{fontFamily: '"Arial",sans-serif'}}>אותה
            שיטת השוואה
            עובדת גם
            עבור עשרת
            הדברות, הן ב<b>שמות
              כ</b> (יתרו)
            והן ב<b>דברים
              ה</b> (ואתחנן)
            –
            שני המקומות
            הנוספים
            בתנ"ך בהם
            קיימת מחלוקת
            בין טעם
            תחתון לטעם
            עליון.</span></p>

      </>
    } else if (langCode === "en") {
      retVal = <>

        <p className="MsoNormal"><b><u>Comparing Taam Tachton and Taam Elyon: Mayse Reuven</u></b></p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - corrected: opening the parser on this pasuk shows the meurav reading by default, not taam tachton; either special reading requires an explicit selection from its own menu */}
        <p className="MsoNormal">Open the Taam Parser on <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>בראשית
            לה:כב</span><span dir="LTR" /><span dir="LTR" /></b> (<span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>מעשה
            ראובן</span><span dir="LTR" /><span dir="LTR" />).
          Since this pasuk isn't yet being viewed through either special reading, it initially
          displays as the combined (meurav) version, with both the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> and <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              עליון</span><span dir="LTR" /><span dir="LTR" /></b> selectors unselected.</p>
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal">Click the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> selector and choose the
          entry under the <span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>מעשה
            ראובן</span><span dir="LTR" /><span dir="LTR" /> heading. The parser jumps to
          the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> version of the passage;
          that selector now shows the current pasuk selected, while <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              עליון</span><span dir="LTR" /><span dir="LTR" /></b> remains unselected.</p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - added taamParser_tachton1_withMenu.jpg (tachton dropdown open, showing selection under Mayse Reuven heading) and taamParser_tachton1.jpg (resulting clean tachton reading tree) */}
        <p className="MsoNormal"><img width={680} height={435} id="Picture 100" src="helpDialogImages/taamParser_tachton1_withMenu.jpg" /></p>
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal"><img width={680} height={436} id="Picture 101" src="helpDialogImages/taamParser_tachton1.jpg" /></p>
        {/* END */}
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal">Now click the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              עליון</span><span dir="LTR" /><span dir="LTR" /></b> selector and choose the
          same entry. The parser jumps to the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              עליון</span><span dir="LTR" /><span dir="LTR" /></b> version of the same
          passage; that selector now shows the current pasuk selected, while <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> reverts to unselected.</p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - added taamParser_elyon_withMenu.jpg (elyon dropdown open, showing selection under Mayse Reuven heading) and taamParser_elyon.jpg (resulting clean elyon reading tree) */}
        <p className="MsoNormal"><img width={680} height={391} id="Picture 102" src="helpDialogImages/taamParser_elyon_withMenu.jpg" /></p>
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal"><img width={680} height={392} id="Picture 103" src="helpDialogImages/taamParser_elyon.jpg" /></p>
        {/* END */}
        <p className="MsoNormal">&nbsp;</p>
        {/* Kalman Claudsky - BHS-308 - Sep 2026 - swapped clause order (elyon first, tachton second) per user request, to flow from the reading just selected back to the earlier one */}
        <p className="MsoNormal">The parse-tree itself changes to match: the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              עליון</span><span dir="LTR" /><span dir="LTR" /></b> unites the content into
          a single unit, while the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> reads this passage as
          spanning two separate pesukim - so, although both trees are built from essentially
          the same words, they branch out differently.</p>
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal">One can switch back to the <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>טעם
              תחתון</span><span dir="LTR" /><span dir="LTR" /></b> reading at any time by
          selecting it again from its own selector, moving back and forth between the
          two versions for comparison.</p>
        <p className="MsoNormal">&nbsp;</p>
        <p className="MsoNormal">The same comparison approach works for the <span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>עשרת
            הדברות</span><span dir="LTR" /><span dir="LTR" />, in both <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>שמות
              כ</span><span dir="LTR" /><span dir="LTR" /></b> (<span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>יתרו</span><span dir="LTR" /><span dir="LTR" />) and <b><span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>דברים
              ה</span><span dir="LTR" /><span dir="LTR" /></b> (<span lang="HE" dir="RTL" style={{fontFamily: '"Arial",sans-serif'}}>ואתחנן</span><span dir="LTR" /><span dir="LTR" />) - the two other places in Tanach where a
          taam tachton/taam elyon divergence exists.</p>

      </>
    }
    return retVal;
  }

  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default TaamParser_Examples;
